import C_FAQSet from '@/components/C_Collections/C_FAQSet/C_FAQSet';
import O_HeaderResponsive from '@/components/O_Organisms/O_Header/O_HeaderResponsive';
import Q_FAQImage from '@/assets/images/Q_FAQImage.png';
import styles from './FAQPage.module.css';
import O_Footer from '@/components/O_Organisms/O_Footer/O_Footer';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';

export default function FAQPage() {
  const { language } = useLanguage();

  const items = [
    {
      title: getTranslation(language, 'pages.faq.blocks.capsules.title'),
      icon: Q_Icon.CapsFillIcon({
        width: 24,
        height: 24,
        fill: '#6C6859',
        stroke: 'none',
      }),
      items: [1, 2, 3, 4, 5, 6].map(i => ({
        title: getTranslation(
          language,
          `pages.faq.blocks.capsules.items.q${i}`
        ),
        description: getTranslation(
          language,
          `pages.faq.blocks.capsules.items.a${i}`
        ),
      })),
    },
    {
      title: getTranslation(language, 'pages.faq.blocks.trees.title'),
      icon: Q_Icon.PlantIcon({
        width: 24,
        height: 24,
        fill: '#6C6859',
        stroke: 'none',
      }),
      items: [1, 2].map(i => ({
        title: getTranslation(language, `pages.faq.blocks.trees.items.q${i}`),
        description: getTranslation(
          language,
          `pages.faq.blocks.trees.items.a${i}`
        ),
      })),
    },
    {
      title: getTranslation(language, 'pages.faq.blocks.other.title'),
      icon: Q_Icon.UserIcon({
        width: 24,
        height: 24,
        fill: '#6C6859',
        stroke: 'none',
      }),
      items: [1, 2].map(i => ({
        title: getTranslation(language, `pages.faq.blocks.other.items.q${i}`),
        description: getTranslation(
          language,
          `pages.faq.blocks.other.items.a${i}`
        ),
      })),
    },
  ];

  return (
    <>
      <O_HeaderResponsive showCreateButton={false} showSearchInput={false} />
      <div className={styles.wrapper}>
        <div className={styles.circle_1}></div>
        <div className={styles.circle_2}></div>
        <h1 className={styles.title}>
          {getTranslation(language, 'header.faq')}
        </h1>
        <div className={styles.image_wrapper}>
          <img src={Q_FAQImage} alt='FAQ' />
        </div>
        <div className={styles.content_wrapper}>
          <C_FAQSet items={items} />
        </div>
        <O_Footer />
      </div>
    </>
  );
}
